import React from 'react'
import { EditComp } from '../../../../components/main/login/mypage/edit/EditComp'

export const Edit = () => {
  return (
    <div>
      <EditComp/>
    </div>
  )
}
